export enum IdentityAppRoutes {
  HOME = '/',
  AUTH_SYNC = '/authSync'
}
